import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

// It is used to define our endpoints and allow to create the API slice
export const UsersApi = createApi({
  // The unique key that defines where the Redux store will store our cache.
  reducerPath: 'UsersApi',

  // The base query to request data.
  // RTK Query ships with fetchBaseQuery, which is a lightweight fetch wrapper that automatically handles request headers and response parsing in a manner similar to common libraries like axios.
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_API_CONNECT}/`,
  }),

  tagTypes: ['User'],
  // keepUnusedDataFor: 1,
  refetchOnMountOrArgChange: 1,
  // The set of operations that we want to perform against the server.
  endpoints: (builder) => ({
    getAllUsers: builder.query({
      query: (data) => {
        return {
          url: `users?page=${data.page}&size=${data.size}&searchid=${data.searchid}`,
          method: 'GET',
          headers: {
            'X-User-Token': data.userToken,
            'X-User-Id': data.userId,
            'X-User-Role': data.userRole,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          },
        }
      },
      // keepUnusedDataFor: 1,
      providesTags: ['User'],
    }),

    

    createUser: builder.mutation({
      query: (newPost) => ({
        url: `users`,
        method: 'POST',
        body: newPost,
        headers: {
          'X-User-Token': localStorage.getItem('userToken'),
          'X-User-Id': localStorage.getItem('userId'),
          'X-User-Role': localStorage.getItem('userRole'),
          'Accept': 'application/json',
          'Content-type': 'application/json; charset=UTF-8',
        }
      }),
      // keepUnusedDataFor: 1,
      invalidatesTags: ['User'],
    }),

    updateUser: builder.mutation({
      query: (data) => {
        return {
          url: `users/${data.id}`,
          method: 'PUT',
          body: data,
          headers: {
            'X-User-Token': data.userToken,
            'X-User-Id': data.userId,
            'X-User-Role': data.userRole,
            'Accept': 'application/json',
            'Content-type': 'application/json; charset=UTF-8',
          }
        }
      },
      // keepUnusedDataFor: 1,
      invalidatesTags: ['User'],
    }),


  }),

})

// Export hooks for usage in functional components, which are auto-generated based on the defined endpoints
export const { useGetAllUsersQuery, useCreateUserMutation, useUpdateUserMutation } = UsersApi